import React, { useEffect, useState } from "react";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import { getDaysInFYMonths, months, secondsToHHMM } from "../../../../Utilitie";
import { MdChangeCircle, MdOutlineChangeCircle } from "react-icons/md";
const NKJYardCharts = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [perDay, setPerDay] = useState(true);
  const [chartData2, setChartData2] = useState(null);
  const product = ["EX_TY_CC", "EX_TY_PREMIUM"];
  const product2 = ["AVG_EXAM_TIME"];

  useEffect(() => {
    let years = [...new Set(data.map((o) => o.F_YEAR))];
    years.sort((a, b) => a.replace("-", "") - b.replace("-", ""));
    let tempChart = {
      dimensions: ["product", ...years],
      series: [],
    };
    let tempChart2 = {
      dimensions: ["product", ...years],
      series: [],
    };
    // tempChart = { ...tempChart, dimensions: ["product", ...years] };
    product.map((p) => {
      let obj = { product: p.replace(/EX_TY_/g, "").replace(/_/g, " ") };

      years.forEach((year) => {
        let tempMonths = [
          ...new Set(
            data
              .filter((o) => o.F_YEAR === year)
              .map((o) => o.MONTH.toUpperCase().slice(0, 3)),
          ),
        ];
        let month = tempMonths.sort(
          (a, b) => months.indexOf(a) - months.indexOf(b),
        );

        let days = month ? getDaysInFYMonths(year.replace("-", "_"), month) : 1;
        const total = data.reduce((sum, o) => {
          if (o.F_YEAR === year) {
            return sum + (o[p] / (perDay ? days : 1) || 0); // safely add
          }
          return sum; // must return sum if condition fails
        }, 0);

        obj[year] = total.toFixed(2);
      });

      tempChart.series.push(obj);
    });
    product2.map((p) => {
      let obj = { product: p.replace(/EX_TY_/g, "").replace(/_/g, " ") };

      years.forEach((year) => {
        let monthsLength = [...new Set(data.filter((o) => o.F_YEAR === year))]
          .length;
        const total = data.reduce((sum, o) => {
          if (o.F_YEAR === year) {
            return sum + (o[p] / (perDay ? monthsLength : 1) || 0); // safely add
          }
          return sum; // must return sum if condition fails
        }, 0);

        obj[year] = total;
      });

      tempChart2.series.push(obj);
    });

    setChartData(tempChart);
    setChartData2(tempChart2);
  }, [data, perDay]);

  return (
    <div>
      <h5>
        CC and Premium{" "}
        <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>
          {" "}
          ({perDay ? "per day" : "Total"}){" "}
        </b>{" "}
        <button
          className="btn btn-sm btn-outline-dark"
          onClick={() => setPerDay(!perDay)}
        >
          <MdChangeCircle />
        </button>
      </h5>
      {chartData && (
        <GroupedBarChart
          data={chartData}
          rotateText={0}
          from={`Block_C`}
          decimal={2}
          chartType="bar"
        />
      )}{" "}
      <hr />
      <h5>
        Avg Exam Time{" "}
        <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>
          ({perDay ? "per day" : "Total"} in HH:MM)
        </b>
      </h5>
      {chartData2 && (
        <GroupedBarChart
          data={chartData2}
          from={`Block_T`}
          rotateText={0}
          chartType="bar"
        />
      )}
    </div>
  );
};
export default NKJYardCharts;
